// extracted by mini-css-extract-plugin
export var fluidSpinner = "spinner-module--fluid-spinner--+vWyn spinner-module--spinner-base--sTkjG";
export var lgSpinner = "spinner-module--lg-spinner--M8wN7";
export var mdSpinner = "spinner-module--md-spinner--XHVN2";
export var smSpinner = "spinner-module--sm-spinner--OUW-g";
export var spinner = "spinner-module--spinner--BW4A8 spinner-module--spinner-base--sTkjG";
export var spinnerBase = "spinner-module--spinner-base--sTkjG";